import React from "react";
import "./Github.css";

export default function end() {
  return (
    <div className="end">
      <a
        href="https://github.com/polinarasskazova295/weather-app-react"
        id="end-link"
      >
        Open-source {" "}
      </a>
        by Polina Rasskazova
    </div>
  );
}
